import { CreateSessionRequest } from '../../types/requests/sessions'
import type {
  SessionCollection,
  SessionItem,
} from '../../types/responses/sessions'
import { apiService } from './apiService'

class SessionService {
  private endpoint = '/sessions'

  async getCurrentSession(): Promise<SessionItem | null> {
    const response = await apiService.get(`${this.endpoint}/current`)

    return response.data.session
  }

  async createSession(request: CreateSessionRequest) {
    const response = await apiService.post(`${this.endpoint}/login`, request)

    return response.data
  }

  async logout() {
    const response = await apiService.post(`${this.endpoint}/logout`, {})

    return response.data
  }

  async getSessions(): Promise<SessionCollection> {
    const response = await apiService.get(`${this.endpoint}`)

    return response.data
  }
}

export const sessionService = new SessionService()
